import { Link, Stack } from "expo-router";
import { View, StyleSheet } from "react-native";

export default function NotFound() {
  return (
    <> 
      <Stack.Screen options={{ title: "404 - Page Not Found" }} />
        <View style={styles.container}>
          <Link href="/">Home</Link>
        </View>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    textAlign: 'center',
    marginTop: 50
  }
});